import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

export type SupportedLanguage = 'zh-TW' | 'en-US' | 'ja-JP' | 'th-TH' | 'id-ID';

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  private translations: { [lang: string]: { [key: string]: string } } = {};
  private currentLangSubject = new BehaviorSubject<SupportedLanguage>(this.getCurrentLanguage());

  constructor(private http: HttpClient) {
    this.loadTranslations();
  }

  get currentLang(): Observable<SupportedLanguage> {
    return this.currentLangSubject.asObservable();
  }

  get currentLangValue(): SupportedLanguage {
    return this.currentLangSubject.value;
  }

  getCurrentLanguage(): SupportedLanguage {

    console.log('環境設定的預設語言:', (environment as any).defaultLanguage);

    // 直接使用環境設定的預設語言，不再從 localStorage 讀取
    return (environment as any).defaultLanguage || 'zh-TW';
  }

  setLanguage(lang: SupportedLanguage): void {
    // 移除 localStorage 儲存，語言現在由環境設定決定
    // localStorage.setItem('language', lang);
    this.currentLangSubject.next(lang);
  }

  translate(key: string, params: { [key: string]: string | number } = {}): string {
    const lang = this.currentLangSubject.value;

    // 檢查翻譯是否已加載
    if (!this.translations[lang]) {
      return key; // 如果翻譯未加載，返回鍵值
    }

    let translation = this.translations[lang][key] || key;

    // 替換參數
    if (params) {
      Object.keys(params).forEach(paramKey => {
        translation = translation.replace(`{{${paramKey}}}`, String(params[paramKey]));
      });
    }

    return translation;
  }

  private loadTranslations(): void {
    const supportedLanguages: SupportedLanguage[] = ['zh-TW', 'en-US', 'ja-JP']; //'th-TH', 'id-ID' 這兩個先不要載入

    supportedLanguages.forEach(lang => {
      this.http.get<{ [key: string]: string }>(`/assets/i18n/${lang}.json`)
        .subscribe(
          data => {
            this.translations[lang] = data;
            // 如果是當前語言，則觸發一次更新，確保組件拿到最新的翻譯
            if (lang === this.currentLangSubject.value) {
              this.currentLangSubject.next(lang);
            }
          },
          err => console.error(`無法加載 ${lang} 的翻譯文件:`, err)
        );
    });
  }
}
